export default __CONFIG__;
